import React , {useEffect, useState} from 'react'; 
import '../assets/css/custom.css'; 
import '../assets/css/client.css'; 
import '../assets/css/font-awesome.css';
import '../assets/css/sweetalert.css';
import '../assets/css/bootstrap.min.css';
import bike from '../assets/img/bike.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; 
import { faEdit, faPlus, faSort, faTrash, faEllipsisVertical, faTrashCan, faPenToSquare} from '@fortawesome/free-solid-svg-icons';
import clientlogo from '../assets/img/user1.jpg'; 
import NoBuilding from "../assets/img/no-tower.png";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Menus from "./menus";
import stopMark from "../assets/img/stop.png";
import TowerIcon from "../assets/img/config-tower.png";
import {commonAPI} from "../services/CommonAPIService"
import {ErrorSource} from '../common/constants'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function Tower()  { 
    const [TowerList, setTowerList] = useState("");
    const [TowerId, setTowerId] = useState("");
    const [BuildingList, setBuildingList] = useState("");
    const [BuildingId, setBuildingId] = useState("");
    const [TowerName, setTowerName] = useState("");
    const [BuildingName, setBuildingName] = useState("");
    const [Loading, setLoading] = useState(false);
    const [UserData, setUserData] = useState("");
    const [AddTowerBtn, setAddTowerBtn] = useState(false);
    const [UpdateTowerBtn, setUpdateTowerBtn] = useState(false);
    const [oldVehicleIndex,setOldVehicleIndex] = useState(null)
    const [vehicleMenu,showVehicleMenu] = useState(null)
    const [DeleteShow, setDeleteShow] = useState(false);
    const [SelectedtowerId,setSelectedTowerId] = useState("")
    console.log("BuildingId", BuildingId)

    const setInputValue = (item) => {
        setShow(true)
        console.log("item", item)
        setAddTowerBtn(false)
        setUpdateTowerBtn(true)
        setBuildingName(item?.buildingId)
        setTowerName(item?.towerName)
        setTowerId(item?.towerId)

    };

    const openCreateModal = () => {
        if(BuildingId){
            setShow(true)
            setAddTowerBtn(true)
            setUpdateTowerBtn(false)
            setBuildingName(BuildingId)
            setTowerName("")
        }else{
            toast.warning("Please select Building");
        }
    };


    const GetBuildingList = async () => {
        const auth = localStorage.getItem("primeProductCode");
        const ProductfactorKey = JSON.parse(auth);
        const endPointVariableKey = {
            ProductId: ProductfactorKey?.primeProductCode,
        }

        try {
            setLoading(true);
            let response = await commonAPI("BuildingLite", undefined, endPointVariableKey)
            if (response.success===true){
                setBuildingList(response?.data);
                setLoading(false);
            }else{
                toast.error("Something went wrong");
                setLoading(false);
            }

        } catch (error) {
            console.log(error);
            setLoading(false);
            const auth = localStorage.getItem("userData");
            const myUserData = JSON.parse(auth);
            const bodyError = JSON.stringify({ 
                "userId": myUserData?.userId,
                "mobileNumber": myUserData?.mobileNumber,
                "requestJSON": null,
                "uri": "/api/Common/Building",
                "errorNumber": "GB01",
                "errorSource": ErrorSource,
                "errorSummary": error.message,
                "errorDescription": error.message,
                "fileClassName": "tower.js",
                "functionName": "GetBuildingList",
            });
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response?.success == true && response?.message?.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }

    } 

    const GetTowerList = async () => {

        try {
            // let myBuildingId;
            const auth = localStorage.getItem("userData");
            const myUserData = JSON.parse(auth);
            setUserData(myUserData);
            setLoading(true);
            const BuildingAuth = localStorage.getItem("BuildingId");
            const myBuildingId = JSON.parse(BuildingAuth);
            

            const endPointVariableKey = {
                buildingId:myBuildingId
            }

            let response = await commonAPI("Tower", undefined, endPointVariableKey);
            if (response?.success===true){
                console.log("Table Tower", response)
                setTowerList(response?.data);
                setLoading(false);
            }else{
                toast.error("Something went wrong");
                setLoading(false);
            }

        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = JSON.stringify({ 
                "userId": UserData?.userId,
                "mobileNumber": UserData?.mobileNumber,
                "requestJSON": null,
                "uri": "api/Master/Tower",
                "errorNumber": "TL01",
                "errorSource": ErrorSource,
                "errorSummary": error?.message,
                "errorDescription": error?.message,
                "fileClassName": "tower.js",
                "functionName": "GetTowerList",
            });
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response?.success == true && response?.message?.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }

    }
    
    useEffect(() => {
        if(BuildingId){
            (async function(){
                await localStorage.setItem("BuildingId", BuildingId?.toString());
            })()

        GetTowerList();
         
        }else if (BuildingId == ""){
            setTowerList("");
        }
    }, [BuildingId])

    useEffect(() => {        
        (async function(){
            const BuildingAuth = localStorage.getItem("BuildingId");
            const myBuildingId = JSON?.parse(BuildingAuth);
            setBuildingId(myBuildingId);
        })()
      }, [])

    const ShowDeleteModal = (item) => {
        setDeleteShow(true);
        setSelectedTowerId(item)

    }

    const DeleteTower = async () => {
        const bodydata = { 
            "towerId": SelectedtowerId?.towerId,
            "modifiedUserId": JSON.stringify(UserData?.userId),
          };
        try {
            setLoading(true);
            const endPointVariableKey = {
                buildingId:BuildingId
            }

            let response = await commonAPI("TowerDelete", bodydata, endPointVariableKey);
            
              if(response?.success == true && response?.message?.length == 0){
                toast.success("Tower Deleted"); 
                setLoading(false); 
                GetTowerList();
                setDeleteShow(false);
              }else{
                toast.error(response.message[0]);
                setLoading(false);
              }
        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = { 
                "userId": UserData?.userId,
                "mobileNumber": UserData?.mobileNumber,
                "requestJSON": bodydata,
                "uri": "/api/Master/Tower",
                "errorNumber": "TD01",
                "errorSource": ErrorSource,
                "errorSummary": error?.message,
                "errorDescription": error?.message,
                "fileClassName": "tower.js",
                "functionName": "DeleteTower",
            };
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response?.success == true && response?.message?.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }
          
    }

     

    const addNewTower = async () => {
        const BuildingAuth = localStorage?.getItem("BuildingId");
            const myBuildingId = JSON.parse(BuildingAuth);
        const bodydata = {
            towerName: TowerName,
            buildingId: myBuildingId,
            createdUserId: JSON.stringify(UserData?.userId),
        }
        try {
            setLoading(true);
            
            if(!TowerName){
                toast.warning("Please enter Tower Name");
                setLoading(false)
            }else{
                const endPointVariableKey = {
                    buildingId:BuildingId
                }
                let response = await commonAPI("TowerAdd", bodydata, endPointVariableKey);
                if(response?.success == true && response?.message?.length == 0){
                    toast.success("Tower Added"); 
                    console.log("Tower Added", bodydata, response.success);
                    GetTowerList();
                    setShow(false)
                    setLoading(false);
                }else{
                    toast.error(response?.message[0]);
                    setLoading(false);
                }
            }    

        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = JSON.stringify({ 
                "userId": UserData?.userId,
                "mobileNumber": UserData?.mobileNumber,
                "requestJSON": bodydata,
                "uri": "/api/Master/Tower/",
                "errorNumber": "AT01",
                "errorSource": ErrorSource,
                "errorSummary": error?.message,
                "errorDescription": error?.message,
                "fileClassName": "tower.js",
                "functionName": "addNewTower",
            });
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response?.success == true && response?.message?.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }
      };


      const UpdateTower = async () => {
        const bodyData = {
            towerName: TowerName,
            buildingId: BuildingId,
            towerId: TowerId,
            modifiedUserId: JSON?.stringify(UserData?.userId),
        }
        try {
            setLoading(true);
            
            if(!TowerName){
                toast.warning("Please enter Tower Name");
                setLoading(false);
            }else{
                const endPointVariableKey = {
                    buildingId:BuildingId
                }
                let response = await commonAPI("TowerAdd", bodyData, endPointVariableKey);
                
                if(response?.success == true && response?.message?.length == 0){
                    toast.success("Tower Updated"); 
                    // console.log(response.success);
                    GetTowerList();
                    setShow(false)
                    setLoading(false);
                }else{
                    toast.error(response?.message[0]);
                    setLoading(false);
                }
            }    

        } catch (error) {
            console.log(error);
            setLoading(false);
            const bodyError = JSON.stringify({ 
                "userId": UserData?.userId,
                "mobileNumber": UserData?.mobileNumber,
                "requestJSON": bodyData,
                "uri": "/api/Master/Tower",
                "errorNumber": "AT01",
                "errorSource": ErrorSource,
                "errorSummary": error?.message,
                "errorDescription": error?.message,
                "fileClassName": "tower.js",
                "functionName": "UpdateTower",
            });
            let response = await commonAPI("ErrorLogMaster", bodyError);
            console.log("statusCode", response);
            if (response?.success == true && response?.message?.length == 0) {
                toast.error("Something went wrong");
                setLoading(false);
            } else {
                setLoading(false);
                toast.error("Something went wrong");
            }
        }
      };  

    function setVehicleIndex(index) {
        console.log(oldVehicleIndex == index, "oldVehicleIndex==index")
        if (oldVehicleIndex == index) {
            setOldVehicleIndex(null)
            showVehicleMenu(null)

        }
        else {
            showVehicleMenu(index)
            setOldVehicleIndex(index)

        }
        // setHideVehicleMenu(true)
    }  
      

    useEffect(() => {
        GetBuildingList();
        // GetTowerList();
    }, [])


    const [show, setShow] = useState(false);

     return (
    <>
    {Loading? 
        <div className="loaderDiv">
          <div className="loader"></div>
        </div> 
      :null}
      {/* <Menus/> */}
 
      <ToastContainer />
      <div className="row mt-5 pt-5" style={{alignItem:'center'}}>
            <div className="col-lg-6 col-md-6">
                <div className="HeadingTop">
                    <h3> Towers </h3>
                    <span> Create and manage individual towers within buildings.</span>
                </div>
            </div>
            <div className="col-lg-6 col-md-6 mb-3 mb-md-0  text-right" style={{alignContent:'center'}}>
                <select size="md" className="sltareamodal col-4 ml-auto" value={BuildingId} onChange={(e) => {
                    console.log("selection", e.target.value)
                    setBuildingId(e.target.value);}}>
                    <option value="">Select Building</option>
                    {BuildingList ? BuildingList?.map((item, index) =>  <option key={index} value={item?.buildingId}>{item?.buildingName}</option>): null}
                </select>
                <Button variant="btn btn-info" onClick={() => openCreateModal()}>+ Create New </Button>{' '}
            </div>
        </div>
      
             






            <Modal size="md" show={show} onHide={() =>  setShow(false)} className="modal-100w modal-md clientmodal right text-end p-0" aria-labelledby="contained-modal-title-vcenter ">
                        <Modal.Header closeButton className='headerMDL'>
                            <Modal.Title id="contained-modal-title-vcenter" onClick={openCreateModal}>
                                {/* Add Tower */}
                                {UpdateTowerBtn ?   <>Update Tower</> : <>Add  Tower</> }
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body className="helpingElelemnt_uuy002">

          
                      <div className="row" id="validation">
                    <div className="col-12">
                       
                            <div className="card-body p-0">
                         
                                <form action="#" className="validation-wizard wizard-circle wizard clearfix" role="application" id="steps-uid-2" novalidate="novalidate">
                                    
                                        <div className="content clearfix">
                                     
                                    
                                    <section id="steps-uid-2-p-0" role="tabpanel" aria-labelledby="steps-uid-2-h-0" className="body current pt-2" aria-hidden="false">
                                        <div className="row text-left">
                                            <div className="col-md-12 mb-2">
                                                <div className="form-group">
                                                    <label for="wfirstName2"> Tower Name  <span className="danger">*</span> </label>
                                                    <input type="text" value={TowerName} onChange={(e)=>{setTowerName(e.target.value)}}  className="form-control required" id="wfirstName2" name="firstName" aria-required="true" /> </div>
                                            </div>
                                            <div className="col-md-12">
                                                <div className="form-group">
                                                    <label for="wlastName2"> Building Name  </label>
                                                    <select name="taskTypes" id="wlastName2" disabled className="form-control" value={BuildingName} onChange={(e)=>{setBuildingName(e.target.value)}}>
                                                        <option value="Select">Select</option>
                                                        {BuildingList ? BuildingList?.map((item, index) =>  <option key={index} value={item?.buildingId}>{item?.buildingName}</option>): null}
                                                    </select>
                                                </div>
                                                    
                                            </div>
                                            

                                        </div>  
                                    </section>
 
                                </div>
                                

                                    </form>
                            </div>
                         
                    </div>
                </div>
            
        </Modal.Body>

        <div className="fixed_allbtn">                        
              <div className="upload_btn">
              <ul role="menu" aria-label="Pagination" className='mb-0'>
                                        {AddTowerBtn ?
                                            // <li aria-hidden="false" aria-disabled="false">
                                            //     <button type="button" className="btn border bg-white" onClick={() => setShow(false)}> Cancel</button>
                                            //     <a className='btn btn-contained' onClick={addNewTower} role="menuitem">Submit </a>
                                            // </li>
                                            <div className="  align-self-start">
                                                <button type="button" className="btn border bg-white" onClick={() => setShow(false)}> Cancel</button>
                                                <button type="button" className="btn btn-info" onClick={() => addNewTower()}> Submit</button>
                                            </div>
                                        :null} 
                                        {UpdateTowerBtn ?
                                            <div className="  align-self-start">
                                                <button type="button" className="btn border bg-white" onClick={() => setShow(false)}> Cancel</button>
                                                <button type="button" className="btn btn-info" onClick={() => UpdateTower()}> Update</button>
                                            </div>
                                            // <li aria-hidden="true">
                                            //     <a href="#finish" onClick={UpdateTower} role="menuitem">Update</a>
                                            // </li>
                                        :null}    
                                    </ul>
                                          </div>
 </div>


      
      </Modal>




  
          <div className="row">
                    <div className="col-12">
    
                                 
                                    <div id="example23_wrapper" className="dataTables_wrapper pt-0">                                        
                                    <div className="row">

                                    {BuildingId ? (!TowerList?.length &&  TowerList?.length != null && 
                                    <div className='bg-white' style={{paddingBottom:"50px",borderRadius: "10px"}}>
                                        <div className='col-12 text-center'>
                                            <img src={NoBuilding} alt="user" class="mx-auto mt-5" style={{height: "100px"}} />
                                        </div>    
                                        <br />
                                        <h3 className='col-12 text-center  NoDataShowTextColor' style={{marginTop: "0px"}}> No Tower found</h3>
                                        <h5 className='col-12 text-center  NoDataShowTextColor' style={{marginTop: "10px"}}> Click on Create New button to add a Tower</h5>
                                    </div>) : null}
                                    {TowerList
                                        ? TowerList?.map((item, index) => (
                                        <div className="col-lg-3 col-md-6 col-sm-12 col-12" key={index}>
                                            <div className="clientTiles" style={{height:115}}>
                                                <div className="ClientImg">
                                                    <div className="tabs_img">
                                                    <img src={TowerIcon} class="img img-responsive" alt="client-img" />
                                                    </div>
                                                    <div class="bars_font">
                                                        <h3 className="font_trigger" onClick={() => {setInputValue(item);}} >
                                                            <FontAwesomeIcon icon={faPenToSquare} />
                                                        </h3>
                                                        <h3 className="font_trigger" onClick={() => {ShowDeleteModal(item);}}>
                                                            <FontAwesomeIcon icon={faTrashCan} />
                                                        </h3>
                                                    </div>
                                                </div>
                                                <div className="ClientText">
                                                    <div className="l-two">
                                                        <h1> {item?.towerName} </h1>
                                                        {/* <h4>{item?.buildingName} </h4> */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        ))
                                        : null}
                                    </div>
                                </div>
                         
          
            </div>
        </div>
        
        <Modal centered show={DeleteShow} onHide={() =>
            setDeleteShow(false)} dialogclassName="modal-100w" aria-labelledby="contained-modal-title-vcenter ">
            <Modal.Body className='p-0' style={{borderRadius: "10px", overflow: "hidden"}}>
                <div className="row px-3" id="validation">
                    <div className="col-12 bg-white pt-3 pb-2">
                        <div className="FnFItem" style={{justifyContent: "flex-start"}}>
                            <div className="FnFtxt">
                                <h2> Delete Tower  </h2>
                                <h3> Are you sure you want to delete? </h3>
                            </div>
                        </div>
                        
                    </div>
                    
                </div>
                <div className='confirmation_btn pb-4 pt-3 px-3' style={{justifyContent: "center", borderTop: "1px solid #dadada"}}>
                        <div className='both_ConfrmBTN col-6' onClick={DeleteTower}>
                            <Button variant="danger">Delete</Button>{' '}
                        </div>
                        <div className='both_ConfrmBTN col-6' onClick={() => setDeleteShow(false)} >
                            <Button variant="light"> Cancel</Button>{' '}
                        </div>
                    </div>
            </Modal.Body>
        </Modal>

        </>)

}
export default Tower